/* eslint-disable no-param-reassign */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  isModalOpened: false,
  myRecentOpenHousesExpanded: false,
  myUpcomingOpenHousesExpanded: false
};

const sendAddToCalendarGA = createAsyncThunk(
  "openHouses/sendAnalytics",
  async (openHouseId, { extra }) => {
    const { analyticsService } = extra;

    analyticsService.sendAddToCalendarEvent({ openHouseId });
  }
);

const sendViewOHonMyActivity = createAsyncThunk(
  "openHouses/sendViewOHonMyActivity",
  async (props, { extra }) => {
    const { analyticsService } = extra;

    analyticsService.sendViewOpenhouseEvent({
      recentNumberOpenHouses: props.recentNumberOpenHouses,
      upcomingNumberOpenHouses: props.upcomingNumberOpenHouses
    });
  }
);

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openModal(state) {
      state.isModalOpened = true;
      document.body.style.position = "fixed";
      document.body.style.width = "100vw";
    },
    closeModal(state) {
      state.isModalOpened = false;
      document.body.style.position = "initial";
      document.body.style.width = "auto";
    },
    expandMyRecentOpenHouses(state) {
      state.myRecentOpenHousesExpanded = true;
    },
    expandMyUpcomingOpenHouses(state) {
      state.myUpcomingOpenHousesExpanded = true;
    }
  }
});

export const {
  closeModal,
  expandMyRecentOpenHouses,
  expandMyUpcomingOpenHouses,
  openModal
} = uiSlice.actions;

export default uiSlice.reducer;

export { sendAddToCalendarGA, sendViewOHonMyActivity };
